// 导出新的 NiceModal 组件
export { default } from './recharge-detail-modal';

// 为了向后兼容，也导出原来的组件结构
export { default as RechargeDetailModalLegacy } from './recharge-detail-modal';